import { useEffect, useState } from "react";
import { Wrench } from "lucide-react";
import { api, C } from "../lib/api";

// Polls the maintenance switch (every 20 s); `push` lets a WS MAINTENANCE notice update it instantly.
export const useMaintenance = (push) => {
  const [m, setM] = useState(null);
  useEffect(() => {
    const load = () => api.get(C.ApiRoutes.MAINTENANCE).then((r) => setM(r.data)).catch(() => {});
    load();
    const id = setInterval(load, 20000);
    return () => clearInterval(id);
  }, []);
  useEffect(() => { if (push) setM(push); }, [push]);
  return m;
};

export const MaintenanceBanner = ({ state, compact = false }) => {
  if (!state?.on) return null;
  return (
    <div data-testid="maintenance-banner" className={`flex items-center gap-3 border border-amber-400/50 bg-amber-950/80 text-amber-100 rounded-xl ${compact ? "px-3 py-1.5 text-xs" : "px-5 py-3 text-sm"} rise`}>
      <Wrench className={compact ? "w-3.5 h-3.5" : "w-5 h-5"} />
      <span className="font-display tracking-wider">MAINTENANCE</span>
      <span className="text-amber-200/80">{state.message || "New hands pause after the current one; seats reopen when staff lift it."}</span>
    </div>
  );
};
